module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "level1",
    attrs: {
      "data-number": "1",
      "id": "authors-note"
    }
  }, [_c('h1', {
    attrs: {
      "data-number": "1"
    }
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', [_vm._v("Benjamin Blackley is a fictional character. However, certain aspects of his story were inspired by the life of William Whiteley, the founder of Whiteleys department store, as described in Linda Stratmann’s fascinating account, "), _c('em', [_vm._v("Whiteley’s Folly: The Life and Death of a Salesman")]), _vm._v(" (Gloucestershire: The History Press, 2004).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0